// Hook custom per recuperare le tipologie immobiliari tramite API.
// Nota: uso axios e TypeScript per tipizzare la risposta e gestire errori e loading.

import { useState, useEffect } from "react";
import axios from "axios";

// Prendo la base URL dell'API dalle variabili d'ambiente
const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

// Tipizzazione di una singola tipologia
interface Tipologia {
    id: number;
    tipologia: string;
    seo_string: string | null;
}

/**
 * useGetTipologie
 * @returns { tipologie, loading, error }
 *
 * Nota per il prossimo dev:
 * - `tipologie` è un array di oggetti Tipologia
 * - `loading` è true mentre la chiamata è in corso
 * - `error` contiene un messaggio di errore in caso di fallimento
 */
export const useGetTipologie = () => {
    const [tipologie, setTipologie] = useState<Tipologia[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        // Funzione auto-invocata async per fare la chiamata API
        (async () => {
            try {
                setLoading(true);
                setError(null);

                // Chiamata POST all'endpoint per recuperare le tipologie
                const response = await axios.post<Tipologia[]>(`${API_BASE_URL}/tipologie`);
                setTipologie(response.data);
            } catch (err) {
                setError("Impossibile recuperare le tipologie");
                console.error("Errore in useGetTipologie:", err);
            } finally {
                setLoading(false);
            }
        })();
    }, []); // chiamata solo al mount

    return { tipologie, loading, error };
};

export default useGetTipologie;